import { jsx as _jsx } from "react/jsx-runtime";
import { formControlClasses } from '@mui/material';
import { FormControlStyled } from './FormControl.styled';
export const FormControl = (props) => {
    return _jsx(FormControlStyled, { ...props });
};
export { formControlClasses };
